import React from 'react';
import { Field, FieldArray } from 'redux-form';
import { BooleanInput } from 'react-admin';

import Properties from '../../../Common/Partials/Properties/Properties';

type Props = {
  lookupProperties: string[],
  index: number,
  item: string,
  record: any
};

const AdUnitTabAdParams = (props: Props) => (
  <div style={{ padding: 20 }}>
    <Field
      component={BooleanInput}
      label="On Clone: Execute Pre Adunit Render"
      name={`${props.item}.explicit_on_clone_execute_preadunitrender`}
      source={`${props.item}.explicit_on_clone_execute_preadunitrender`}
      style={{ width: '280px' }} /><br />

    <FieldArray
      addItemLabel="Add Property"
      adUnitIndex={props.index}
      component={Properties}
      lookupProperties={props.lookupProperties}
      name={`${props.item}.properties`}
      mainLabel=""
      record={props.record} /><br />
  </div>
);

export default AdUnitTabAdParams;



// WEBPACK FOOTER //
// ./src/views/Components/Placements/Partials/AdUnitTabAdParams.tsx